import { ArrowRight, Lock } from "lucide-react";

import { Card } from "@/components/ui/card";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";

import { Agent } from "../types";
import { AgentIcon } from "./AgentIcon";

interface AgentCardProps {
  agent: Agent;
  onTryNow: (agentId: string) => void;
  disabled?: boolean;
}

export const AgentCard = ({
  agent,
  onTryNow,
  disabled = false,
}: AgentCardProps) => {
  const handleClick = () => {
    if (!disabled) {
      onTryNow(agent.id);
    }
  };

  return (
    <Card
      onClick={handleClick}
      className={cn(
        "flex items-start gap-3 p-4 border border-gray-100",
        "transition-all duration-200 ease-in-out",
        disabled
          ? "bg-gray-50 cursor-not-allowed opacity-60"
          : "bg-white cursor-pointer hover:-translate-y-0.5 hover:shadow-md",
      )}
    >
      {/* Icon */}
      <div className={cn("flex-shrink-0 mt-0.5", disabled && "opacity-50")}>
        <AgentIcon
          iconName={agent.iconName}
          category={agent.category}
          size={24}
        />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <Typography
            size="l1"
            className={cn(
              "font-semibold",
              disabled ? "text-gray-500" : "text-gray-900",
            )}
          >
            {agent.name}
          </Typography>
          {disabled && <Lock className="h-4 w-4 text-gray-400 flex-shrink-0" />}
        </div>
        <Typography
          size="b3"
          className={cn(
            "mt-0.5",
            disabled ? "text-gray-400" : "text-gray-600",
          )}
        >
          {agent.description}
        </Typography>
      </div>

      {/* Arrow */}
      <div className="flex-shrink-0 mt-0.5">
        <ArrowRight
          className={cn(
            "h-5 w-5",
            disabled ? "text-gray-300" : "text-gray-400",
          )}
        />
      </div>
    </Card>
  );
};
